export default __webpack_public_path__ + "static/media/email.92d23db9.svg";